/**
 * The Gompa mark — a flame inside the dharmachakra ring.
 *
 * Redrawn from the app's `GompaMark`, which builds it from a bordered View and
 * the Ionicons flame so the brand mark and the offering icon are literally the
 * same shape. Same reasoning here: the flame comes from the shared icon set.
 *
 * The full eight-spoked wheel is the more correct dharmachakra, but eight
 * spokes collapse into a textured disc at 40px. A plain ring keeps the reading
 * and survives the size.
 */
import Icon from './Icon';

const RING_WEIGHT = 0.075;
const FLAME_SCALE = 0.58;

export default function GompaMark({ size = 40, color = 'var(--accent)', className }) {
  return (
    <span
      className={['mark', className].filter(Boolean).join(' ')}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: `${Math.max(2, Math.round(size * RING_WEIGHT))}px solid ${color}`,
        color,
        display: 'grid',
        placeItems: 'center',
      }}
      aria-hidden="true"
    >
      <Icon name="flame" size={Math.round(size * FLAME_SCALE)} solid />
    </span>
  );
}
